/** Fields the compact grid must copy from Formik when row ids stay the same. */
export const CALC_ROW_MONEY_KEYS = [
  "sales_price",
  "purchase_price",
  "discount",
  "surcharge",
  "quantity",
  "line_total",
  "cost_total",
  "hours",
  "hour_rate",
  "cost_hour_rate",
  "description",
  "nested_calculation",
  "nested_calculation_id",
];

function moneyEqual(a, b) {
  if (a === b) return true;
  if (a == null && b == null) return true;
  if (typeof a === "object" || typeof b === "object") {
    try {
      return JSON.stringify(a) === JSON.stringify(b);
    } catch {
      return false;
    }
  }
  return String(a) === String(b);
}

/**
 * When Kalkyle save / nested editor updates money on the same line id,
 * OfferCalculationItems used to keep the stale local row (identity-only sync).
 */
export function mergeRemoteRowMoney(local, remote) {
  if (!local || !remote) return local;
  let changed = false;
  const next = { ...local };
  for (const key of CALC_ROW_MONEY_KEYS) {
    if (!Object.prototype.hasOwnProperty.call(remote, key)) continue;
    if (moneyEqual(local[key], remote[key])) continue;
    next[key] = remote[key];
    changed = true;
  }
  return changed ? next : local;
}
